module.exports = __webpack_public_path__ + "img/gls_gbt31_1_1988.prt.371da4da.jpg";